import moment from 'moment';

export const getDurationFromStartDate = (startDate, duration = 0) => {
  const fechaFinal = moment(startDate).add(duration, 'minutes');
  const formatoFinal = fechaFinal;

  return formatoFinal;
};
